<template>
  <div class="lad-filter--date-range-content">
    <slot name="before-range" />

    <client-only>
      <el-date-picker
        ref="datepicker"
        v-model="privateValues"
        value-format="yyyy-MM-dd"
        type="daterange"
        :popper-class="popoverClass"
        :picker-options="pickerOptions"
        unlink-panels
        @change="handleApply"
      />
    </client-only>

    <slot name="buttons" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadFilterDateRange',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    value: { type: Array, default: [], required: true },
    open: { type: Number, default: 0, required: true },
    handleApply: { type: Function, default() {}, required: true },
    // eslint-disable-next-line vue/no-boolean-default
    widthSidebar: { type: Boolean, default: true },
    // eslint-disable-next-line vue/require-prop-type-constructor
    minDay: { type: Number | null, require: false, default: null },
  },
  data() {
    return {
      base: 'filters.date',
      privateValues: [],
    }
  },
  computed: {
    ...mapState('search', {
      searchForm: 'form',
    }),
    popoverClass() {
      const list = ['datepicker-filter--range-search']

      if (!this.widthSidebar) {
        list.push('only-close')
      }

      return list.join(' ')
    },
    pickerOptions() {
      let shortcuts = []

      if (this.widthSidebar) {
        shortcuts = [
          {
            text: this.$t(`${this.base}.datepicker.next_week`),
            onClick: (picker) => {
              const start = this.$dayjs().add(1, 'day').startOf('day')
              const end = start.add(7, 'day').endOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            },
          },
          {
            text: this.$t(`${this.base}.datepicker.next_month`),
            onClick: (picker) => {
              const start = this.$dayjs().add(1, 'day').startOf('day')
              const end = start.add(1, 'month').endOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            },
          },
          {
            text: this.$t(`${this.base}.datepicker.next_3_month`),
            onClick: (picker) => {
              const start = this.$dayjs().add(1, 'day').startOf('day')
              const end = start.add(3, 'month').endOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            },
          },
          {
            text: this.$t('general.clear'),
            onClick: (picker) => {
              picker.$emit('pick', [])
            },
          },
        ]
      }

      shortcuts.push({
        // text: this.$t('general.close'),
        text: 'X',
        onClick: (picker) => {
          picker.$emit('pick', picker.value)
        },
      })

      return {
        disabledDate: (time) => {
          const min = this.minDay === null ? Date.now() : this.minDay

          return time.getTime() < min
        },
        shortcuts,
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.privateValues = newValue
      },
    },
    open(val) {
      this.$refs.datepicker.$el.click()
    },
    privateValues(newValue) {
      this.$emit('update-values', newValue)
    },
  },
}
</script>

<style lang="scss">
.lad-filter--date-range-content {
  display: inline-block;
  position: relative;

  .el-date-editor {
    position: absolute;
    bottom: 0;
    width: 10px;
    height: 10px;
    overflow: hidden;
    z-index: 1;
  }

  & > .el-button {
    position: relative;
    z-index: 2;

    i {
      display: none;

      & + span {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 400px) {
    width: 100%;
  }
}

.datepicker-filter--range-search {
  &.el-picker-panel [slot='sidebar'],
  .el-picker-panel__sidebar {
    width: 140px;

    & + .el-picker-panel__body {
      margin-left: 140px;
    }
  }

  .el-picker-panel__sidebar {
    .el-picker-panel__shortcut {
      &:nth-last-child(-n + 2) {
        position: absolute;
        bottom: 6px;
      }

      &:nth-last-child(-n + 1) {
        display: none;
      }
    }
  }

  .el-date-table {
    td.disabled {
      div {
        background-color: #fbfbfb;
      }
    }
  }

  &.only-close {
    .el-picker-panel__sidebar {
      display: none;

      & + .el-picker-panel__body {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 770px) {
    top: 0 !important;
    left: 0 !important;
    bottom: 0 !important;
    position: fixed !important;
    border-radius: 0;

    .popper__arrow {
      display: none;
    }

    &.el-picker-panel [slot='sidebar'],
    .el-picker-panel__sidebar {
      width: 100%;
      position: fixed;
      background: white;
      height: auto;
      z-index: 10;
      bottom: auto;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      & + .el-picker-panel__body {
        margin-left: 0;
        margin-top: 60px;
        z-index: 5;
      }
    }

    .el-picker-panel__sidebar {
      padding-right: 64px;

      .el-picker-panel__shortcut {
        display: inline-block;
        width: auto;

        &:nth-last-child(-n + 2) {
          position: relative;
          bottom: initial;
          right: initial;
        }

        &:nth-last-child(-n + 1) {
          position: absolute;
          right: 6px;
          top: 6px;
          cursor: pointer;
          border: 1px solid #e4e4e4;
          display: flex;
          padding: 0;
          width: 50px;
          height: 50px;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .el-picker-panel__body {
      overflow: auto;
      min-width: inherit;
    }

    &.has-sidebar {
      width: inherit;
      height: 100%;
      overflow-y: auto;

      .el-picker-panel__sidebar {
        border-width: 2px;
      }

      &::-webkit-scrollbar {
        width: 0;
      }

      .is-left {
        border: 0;
      }
    }

    &.only-close {
      .el-picker-panel__sidebar {
        display: block;
        min-height: 67px;
        box-shadow: none;

        button {
          border: 0 !important;
        }
      }
      .el-picker-panel__body {
        margin-top: 60px;
      }
    }

    .el-picker-panel__content {
      width: inherit;
      float: none;
    }

    &[x-placement^='bottom'] {
      margin: 0;
    }
  }
}
</style>
